import '../../global.css'
import { Stack, useNavigationContainerRef } from 'expo-router'
import { toast, Toaster } from 'sonner'
import { useEffect, useState } from 'react'
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react-native'

import { httpBatchLink } from '@trpc/client'
import { trpc } from '@/trpcReact'
import { TooltipProvider } from '@/components/ui/tooltip.tsx'
import { TouchProvider } from '@/components/ui/hybrid-tooltip'

const navigationIntegration = Sentry.reactNavigationIntegration({
  enableTimeToInitialDisplay: false,
})

Sentry.init({
  dsn: 'https://b5c5081ca7ef8801b8c63e949ddbf33b@o4506027837620224.ingest.us.sentry.io/4508744563294208',
  tracesSampleRate: 1.0, // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing. Adjusting this value in production.
  integrations: (integrations) => {
    const toDisable = ['AppRegistry', 'ReactNativeTracing', 'NativeFrames']
    const integrationsStripped = integrations.filter((integration) => {
      return !toDisable.includes(integration.name)
    })
    integrationsStripped.push(navigationIntegration)

    return integrationsStripped
  },
  enableNativeFramesTracking: false,
  enabled: !__DEV__,
})

function RootLayout() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        mutationCache: new MutationCache({
          onError: (err, _variables, _context, mutation) => {
            Sentry.withScope((scope) => {
              scope.setContext('mutation', {
                mutationId: mutation.mutationId,
                variables: mutation.state.variables,
              })
              if (mutation.options.mutationKey) {
                scope.setFingerprint(
                  // Duplicate to prevent modification
                  Array.from(mutation.options.mutationKey) as string[],
                )
              }
              Sentry.captureException(err)
            })
          },
        }),
        queryCache: new QueryCache({
          onError: (error, query) => {
            Sentry.withScope((scope) => {
              scope.setContext('query', { queryHash: query.queryHash })
              scope.setFingerprint([query.queryHash])
              Sentry.captureException(error)
            })
            toast.error(error.message || 'Something went wrong. Please try again later.', {
              id: query.queryHash,
            })
          },
        }),
      }),
  )

  const [trpcClient] = useState(() => {
    return trpc.createClient({
      links: [
        httpBatchLink({
          url: `/api/trpc`,
        }),
      ],
    })
  })

  const ref = useNavigationContainerRef()
  useEffect(() => {
    if (ref) {
      navigationIntegration.registerNavigationContainer(ref)
    }
  }, [ref])

  return (
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
      <div
        className="fixed inset-0 -z-10 bg-[radial-gradient(45%_45%_at_50%_50%,rgba(66,133,244,0.08),rgba(66,133,244,0))]"
        aria-hidden="true"
      />
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <TouchProvider>
            <TooltipProvider>
              <Stack screenOptions={{ headerShown: false }}>
                {/*<Stack.Screen name="invitations" options={{ headerShown: false }} />*/}
                {/*<Stack.Screen name="+not-found" />*/}
              </Stack>
            </TooltipProvider>
          </TouchProvider>
        </QueryClientProvider>
      </trpc.Provider>
      <Toaster className="pointer-events-auto" duration={6000} closeButton />
    </Sentry.ErrorBoundary>
  )
}
export default Sentry.wrap(RootLayout)
